import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import "./DevsphireDev.css"


const DevsphireDev = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const Vivek =
    "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735560298/vivek_cbs3cu.png";
  const Aakash =
    "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735896077/aakash_1_xpscox.jpg";

  return (
    <div
      className="container py-5 my-5 rounded"
      style={{
        backgroundImage:
          "linear-gradient(to right bottom, #051937, #00426c, #006f8a, #009c83, #14c55a)",
      }}
    >
      <h2
        className="text-capitalize text-center mb-5 text-white"
        style={{
          fontFamily: "Noto Sans Mono, serif",
        }}
      >
        Meet the Devs
      </h2>

      <div className="row align-items-center mb-5" data-aos="zoom-in-up">
        <div className="col-md-6 text-center">
          <img
            src={Aakash}
            alt="Aakash"
            className="rounded w-50 mb-3 aakashJpg"
            draggable="false"
          />
        </div>
        <div className="col-md-6">
          <h2
            className="text-capitalize text-white text-center mb-3"
            style={{
              fontFamily: "Noto Sans Mono, serif",
            }}
          >
            Aakash Kumar Gorai
          </h2>
          <div className="text-center text-white mt-1 mb-2">
            <span>
              Connect on &nbsp;
              <a
                href="https://www.linkedin.com/in/aakash-gorai/"
                target="_blank"
                className="text-white"
                style={{ textDecoration: "none" }}
              >
                Linkedin
              </a>
            </span>
            <span className="ms-2">
              or &nbsp;
              <a
                href="https://github.com/aakash-gorai/"
                target="_blank"
                className="text-white"
                style={{ textDecoration: "none" }}
              >
                Github
              </a>
            </span>
          </div>
          <p className="text-center text-white">
            Software Engineer @ JPMorganChase
          </p>
          <p
            className="text-justify p-2 text-white"
            style={{
              wordSpacing: "2px",
            }}
          >
            Graduated with B.Tech in Computer Science from KIIT Bhubaneswar. A
            dedicated full-stack web developer with a passion for learning and
            implementing innovative technologies. Designed and implemented the
            complex backend architecture and logic for this website.
          </p>
        </div>
      </div>

      <div className="row align-items-center" data-aos="zoom-in-down">
        <div className="col-md-6 order-md-2 text-center">
          <img
            src={Vivek}
            alt="Vivek"
            className="rounded w-50 mb-3 vivekJpg"
            draggable="false"
          />
        </div>
        <div className="col-md-6 order-md-1">
          <h2
            className="text-capitalize text-white text-center mb-3"
            style={{
              fontFamily: "Noto Sans Mono, serif",
            }}
          >
            Vivek Pramanik
          </h2>
          <div className="text-center text-white mt-1 mb-2">
            <span>
              Connect on&nbsp;
              <a
                href="https://www.linkedin.com/in/vivekpramanik/"
                target="_blank"
                className="text-white"
                style={{ textDecoration: "none" }}
              >
                Linkedin
              </a>
            </span>
            <span className="ms-2">
              or &nbsp;
              <a
                href="https://github.com/icodervivek/"
                target="_blank"
                className="text-white"
                style={{ textDecoration: "none" }}
              >
                Github
              </a>
            </span>
          </div>
          <p className="text-center text-white">
            Pursuing MCA @ Ranchi University
          </p>
          <p
            className="text-justify p-2 text-white"
            style={{
              wordSpacing: "2px",
            }}
          >
            Pursuing MCA in Computer Science from Ranchi University. A
            passionate full-stack web developer with a knack for deconstructing
            and creating systems. Enthusiastically engaged in web development,
            responsible for designing and implementing the intricate frontend of
            this website.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DevsphireDev;
